import React from 'react';
import LegalPage from '../../components/LegalPage';

const DatenschutzPage: React.FC = () => (
  <LegalPage contentKey="page_datenschutz" seoTitleKey="seo.datenschutz_title" canonicalPath="/datenschutz" />
);

export default DatenschutzPage;
